import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/Index',
    name: 'Index',
    component: ()=>import('../views/index.vue')
  },
  {
    path: '/MyCenter',
    name: 'MyCenter',
    component: ()=>import('../views/MyCenter.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    component: ()=>import('../views/Login.vue')
  },
  {
    path: '/GoodDetail/:id',
    name: 'GoodDetail',
    component: ()=>import('../views/GoodDetail.vue')
  },
  {
    path: '/Cart',
    name: 'Cart',
    component: ()=>import('../views/Cart.vue')
  },
  // {
  //   path: '/GoodList/:categoryId',
  //   name: 'GoodList',
  //   component: ()=>import('../views/GoodList.vue')
  // },
  {
    path: '/GoodList/',
    name: 'GoodList',
    component: ()=>import('../views/GoodList.vue')
  },
  {
    path: '/GoodCategory',
    name: 'GoodCategory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/GoodCategorynew.vue')
  },
  {
    path: '/OrderList/:status',
    name: 'OrderList',
    component: ()=>import('../views/OrderListnew.vue')
  },
  {
    path: '/IntegrallogList/:sdworkerid',
    name: 'IntegrallogList',
    component: ()=>import('../views/IntegrallogList.vue')
  },
  {
    path: '/StageIntegral/:tel',
    name: 'StageIntegral',
    component: ()=>import('../views/StageIntegral.vue')
  },
  {
    path: '/ReciveAddrs',
    name: 'ReciveAddrs',
    component: ()=>import('../views/ReciveAddrs.vue')
  },
  {
    path: '/ReciveAddrsEdit/:addrid',
    name: 'ReciveAddrsEdit',
    component: ()=>import('../views/ReciveAddrsEdit.vue')
  },
  {
    path: '/Confirm/:skuid',
    name: 'Confirm',
    component: ()=>import('../views/Confirm.vue')
  },
  {
    path: '/LuckDraw/:period',
    name: 'LuckDraw',
    component: ()=>import('../views/LuckDraw.vue')
  },
  {
    path: '/Process/:sdworkerId',
    name: 'Process',
    component: ()=>import('../views/Process.vue')
  },
  {
    path: '/LuckDrawRecord',
    name: 'LuckDrawRecord',
    component: ()=>import('../views/LuckDrawRecord.vue')
  },
  {
    path: '/LuckDrawRecord3',
    name: 'LuckDrawRecord3',
    component: ()=>import('../views/LuckDrawRecord3.vue')
  },
  {
    path: '/MemberCard',
    name: 'MemberCard',
    component: ()=>import('../views/MemberCard.vue')
  },
  {
    path: '/DrawShare/:period/:index/:name',
    name: 'DrawShare',
    component: ()=>import('../views/DrawShare.vue')
  },  
  {
    path: '/ConverIntegral/:sdworkerid',
    name: 'ConverIntegral',
    component: ()=>import('../views/ConverIntegral.vue')
  },
  {
    path: '/LuckDraw2/:period',
    name: 'LuckDraw2',
    meta: {
      keepAlive: true // 需要被缓存
    },
    component: ()=>import('../views/LuckDraw2.vue'),
    
  },
  {
    path: '/TeamIndex',
    name: 'TeamIndex',
    component: ()=>import('../views/TeamIndex.vue'),
  },
  {
    path: '/TeamSearch',
    name: 'TeamSearch',
    component: ()=>import('../views/TeamSearch.vue'),
    
  },
  {
    path: '/TeamEdit',
    name: 'TeamEdit',
    component: ()=>import('../views/TeamEdit.vue'),
    
  },
  {
    path: '/TeamInvite',
    name: 'TeamInvite',
    component: ()=>import('../views/TeamInvite.vue'),
    
  },
  {
    path: '/TeamLog',
    name: 'TeamLog',
    component: ()=>import('../views/TeamLog.vue'),
    
  },
  {
    path: '/activity',
    name: 'activity',
    component: ()=>import('../views/activity.vue'),
    
  },
  {
    path: '/AllTeamSearch',
    name: 'AllTeamSearch',
    component: ()=>import('../views/AllTeamSearch.vue'),
    
  },
  {
    path: '/TeamDetail/:teamId',
    name: 'TeamDetail',
    component: ()=>import('../views/TeamDetail.vue'),
    
  },
  {
    path: '/TeamRank',
    name: 'TeamRank',
    component: ()=>import('../views/TeamRank.vue'),
    
  },
  {
    path: '/OtherProcess/:sdworkerId',
    name: 'OtherProcess',
    component: ()=>import('../views/OtherProcess.vue')
  },
  {
    path: '/TeamTransfer/:teamId',
    name: 'TeamTransfer',
    component: ()=>import('../views/TeamTransfer.vue'),
    
  },
  {
    path: '/PrizeList',
    name: 'PrizeList',
    component: ()=>import('../views/PrizeList.vue'),
    
  }, 
  {
    path: '/ConvertList',
    name: 'ConvertList',
    component: ()=>import('../views/ConvertList.vue'),
    
  },
  {
    path: '/ConvertAddrsEdit',
    name: 'ConvertAddrsEdit',
    component: ()=>import('../views/ConvertAddrsEdit.vue')
  }, 
  {
    path: '/ConvertAddrsDetail',
    name: 'ConvertAddrsDetail',
    component: ()=>import('../views/ConvertAddrsDetail.vue')
  }, 
  {
    path: '/activity2023',
    name: 'activity2023',
    component: ()=>import('../views/activity2023.vue')
  },
  {
    path: '/contract',
    name: 'contract',
    component: ()=>import('../views/contract.vue')
  }, 
  {
    path: '/RewardLogList',
    name: 'RewardLogList',
    component: ()=>import('../views/RewardLogList.vue'),
    
  },
  {
    path: '/activity2Period2023',
    name: 'activity2Period2023',
    component: ()=>import('../views/activity2Period2023.vue')
  },
  {
    path: '/Reward2LogList',
    name: 'Reward2LogList',
    component: ()=>import('../views/Reward2LogList.vue'),
    
  },  
  // {
  //   path: '/LYLuckDraw',
  //   name: 'LYLuckDraw',
  //   component: ()=>import('../views/LYLuckDraw.vue')
  // },
  {
    path: '/ActivityRule',
    name: 'ActivityRule',
    component: ()=>import('../views/ActivityRule.vue')
  },
  {
    path: '/WechatMiniLogin/:sdworkerId',
    name: 'WechatMiniLogin',
    component: ()=>import('../views/WechatMiniLogin.vue')
  },
  {
    path: '/Prize2List',
    name: 'Prize2List',
    component: ()=>import('../views/2023period/Prize2List.vue'),
    
  },
  {
    path: '/LuckDraw2024/:period',
    name: 'LuckDraw2024',
    component: ()=>import('../views/draw2024/LuckDraw.vue')
  },
  {
    path: '/LuckDrawRecord2024',
    name: 'LuckDrawRecord2024',
    component: ()=>import('../views/draw2024/LuckDrawRecord.vue')
  },
  {
    path: '/MyRank',
    name: 'MyRank',
    component: ()=>import('../views/draw2024/MyRank.vue')
  },
  {
    path: '/MemberLevel',
    name: 'MemberLevel',
    component: ()=>import('../views/draw2024/MemberLevel.vue')
  },
  {
    path: '/PrizeAddrs',
    name: 'PrizeAddrs',
    component: ()=>import('../views/PrizeAddrs.vue')
  },
  {
    path: '/PrizeAddrsEdit/:addrid',
    name: 'PrizeAddrsEdit',
    component: ()=>import('../views/PrizeAddrsEdit.vue')
  },
  {
    path: '/SizeEdit:drawId',
    name: 'SizeEdit',
    component: ()=>import('../views/draw2024/SizeEdit.vue')
  },
  {
    path: '/Luck2Draw2024/:period',
    name: 'Luck2Draw2024',
    component: ()=>import('../views/draw2024/Luck2Draw.vue')
  },
  {
    path: '/Luck2DrawRecord2024',
    name: 'Luck2DrawRecord2024',
    component: ()=>import('../views/draw2024/Luck2DrawRecord.vue')
  },
  {
    path: '/MemberReward',
    name: 'MemberReward',
    component: ()=>import('../views/activity2025/MemberReward.vue')
  },
  {
    path: '/SignReward',
    name: 'SignReward',
    component: ()=>import('../views/activity2025/SignReward.vue')
  },
  {
    path: '/Auth',
    name: 'Auth',
    component: ()=>import('../views/activity2025/Auth.vue')
  },
  {
    path: '/Sign',
    name: 'Sign',
    component: ()=>import('../views/activity2025/Sign.vue')
  },
  {
    path: '/Reward2025LogList',
    name: 'Reward2025LogList',
    component: ()=>import('../views/activity2025/RewardLogList.vue'),
    
  },  
  {
    path: '/CompanySign',
    name: 'CompanySign',
    component: ()=>import('../views/activity2025/CompanySign.vue')
  },
  {
    path: '/PeriodReward',
    name: 'PeriodReward',
    component: ()=>import('../views/activity2025/PeriodReward.vue')
  },
  {
    path: '/SignEdit',
    name: 'SignEdit',
    component: ()=>import('../views/activity2025/SignEdit.vue')
  },
  {
    path: '/MyRank2025',
    name: 'MyRank2025',
    component: ()=>import('../views/activity2025/MyRank.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
